// extracted by mini-css-extract-plugin
export default {"fade-in-section":"FadeInOnScroll_fade-in-section__tSCvy","is-visible":"FadeInOnScroll_is-visible__IDcZ3"};